export const CREATE_REPORT_TYPE_MUTATION = `
  mutation CreateReportType($object: report_types_insert_input!) {
    insert_report_types_one(object: $object) {
      id
      report_type_name
      report_type_description
      report_type_status
      company_id
      report_type_tags
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`;

export const UPDATE_REPORT_TYPE_MUTATION = `
  mutation UpdateReportType($id: Int!, $set: report_types_set_input!) {
    update_report_types_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      report_type_name
      report_type_description
      report_type_status
      company_id
      report_type_tags
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`;

export const DELETE_REPORT_TYPE_MUTATION = `
  mutation DeleteReportType($id: Int!) {
    delete_report_types_by_pk(id: $id) {
      id
      report_type_name
    }
  }
`;
